module.exports = __webpack_public_path__ + "img/jiaotangzhenguoyanwobing.65ca6b36.jpg";